import { mapActions, mapState } from "vuex";
import { showError } from '@/helpers/globalHelpers';

export default {
    name: "AddUserSignerReturnDialog",
    data() {
        return {
            addUserSignerReturnForm: {
                user_signer: null,
                asset_assignment_return_id: null,
                description: null
            },
            responsablesRules: [(v) => !!v || 'El usuario es requerido'],
            loadingSave: false,
            listError: [],
        }
    },

    props: {
        value: Boolean,
        item: Object,
    },

    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
        ...mapState({
            responsibles: (state) => state.security.usersActive,
        }),
    },

    created() {
        this.getUsersActive()
    },

    methods: {
        ...mapActions('security', ['getUsersActive']),
        ...mapActions('assetAssignment',['addSignerUserAssetAssignmentReturn']),

        async addSignerUser() {
            this.loadingSave = true;
            this.addUserSignerReturnForm.asset_assignment_return_id = this.item?.id;

            const { error } = await this.addSignerUserAssetAssignmentReturn({ data: this.addUserSignerReturnForm });

            if (error) showError(error);

            await this.$emit('loadAssignmentReturnById');

            this.addUserSignerReturnForm = {
                user_signer: null,
                asset_assignment_return_id: null,
                description: null
            }

            this.loadingSave = false;
            this.dialog = false;
        },

        close() {
            this.dialog = false;
            (this.addUserSignerReturnForm = {
                user_signer: null,
                asset_assignment_return_id: null,
                description: null
            }),
                (this.listError = []);
            this.$refs?.form?.resetValidation();
        },

    },
};
